import { SemanticUI } from '@iterable/deprecated_react_components';
import { CAST_SELECT_OPTIONS } from './constants';

// type Props = {
//   /** The castType of the criteria property. */
//   castType: string,
//   /** If the text field is disabled. */
//   disabled: boolean,
//   /** If the field has an error. */
//   error: boolean,
//   /** Array comtaining the group index, query index and criteria property index. */
//   fieldIdentifier: [],
//   /** Callback function when field value is changed. */
//   onChange: () => {},
//   /** Callback function when the casttype action value is changed. */
//   onChangeCastType: () => {},
//   /** Placeholder test of the field. */
//   placeholder: string,
//   /** The value of the field. */
//   value: string,
// };

export const CriteriaLongField = ({
  // initializing castType to null, because by default it's uncasted
  castType = null,
  disabled = false,
  error,
  fieldIdentifier = [],
  onChange = () => {},
  onChangeCastType = () => {},
  placeholder,
  value,
}) => (
  <SemanticUI.Input
    action={
      <>
        <SemanticUI.Select
          placeholder="Cast type..."
          compact
          data-test="criteria-long-field-cast-select"
          // once casted, there is no way to uncast unless the field is removed
          onChange={(e, { value: newCastType }) =>
            onChangeCastType(newCastType, ...fieldIdentifier)
          }
          options={CAST_SELECT_OPTIONS}
          value={castType}
          disabled={disabled}
        />
      </>
    }
    data-test="criteria-long-field"
    disabled={disabled}
    error={error}
    onChange={(e, { value: newValue }) => onChange(newValue, ...fieldIdentifier)}
    placeholder={placeholder}
    value={value}
  />
);
